import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { CertificateOfOccupancyTypeOptions } from '@apply/constants';
import { usePropertyCertificateOfOccupancy } from '../../../../../../queries/PropertyFields';
import { DropDownBoxComponentSpacing, DropDownBoxLabelSize } from '@apply/components/src/components/controls/DropDownBox';
export interface CertificateOfOccupancyProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const CertificateOfOccupancy: React.FC<CertificateOfOccupancyProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const label =
        'Does the property have a certificate of occupancy or local equivalent meaning that it can be legally inhabited?';
    const [certificateOfOccupancy, set_certificateOfOccupancy] = usePropertyCertificateOfOccupancy(propertyGuid);

    const certificateOfOccupancyList = CertificateOfOccupancyTypeOptions.slice()
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((o) => ({
            display: o.name,
            value: o.id,
        }));

    const findCertificateOfOccupancyByValue = (value: number | undefined) => {
        return certificateOfOccupancyList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findCertificateOfOccupancyByValue(certificateOfOccupancy)}
                />
            ) : (
                <DropDownBox
                    id={'certificateOfOccupancyDropDown'}
                    value={certificateOfOccupancy}
                    onChange={(value) => set_certificateOfOccupancy(value)}
                    required={required}
                    dataSource={certificateOfOccupancyList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                    labelSize={DropDownBoxLabelSize.Medium}
                    componentSpacing={DropDownBoxComponentSpacing.LargeSpacing}
                />
            )}
        </>
    );
};
